import React from 'react'
import PropTypes from 'prop-types'
import { Label, Form, Input } from 'semantic-ui-react'

const Info = ({ info, ...props }) => <Label {...props}>{info}</Label>

Info.propTypes = {
  info: PropTypes.string
}

export default function SemanticFormField ({
  input,
  type,
  label,
  placeholder,
  infoText,
  infoProps,
  infoBefore,
  meta: { touched, error, warning },
  as: As = Input,
  ...props
}) {
  function handleChange (e, { value }) {
    return input.onChange(value)
  }
  return (
    <Form.Field inline>
      {infoText && infoBefore && <Info {...infoProps} info={infoText} />}
      <As
        {...props}
        {...input}
        value={input.value}
        type={type}
        label={label}
        placeholder={placeholder}
        onChange={handleChange}
      />
      {touched &&
        ((error && (
          <span>
            <i>{error}</i>
          </span>
        )) ||
          (warning && (
            <span>
              <i>{warning}</i>
            </span>
          )))}
      {infoText && !infoBefore && <Info {...infoProps} info={infoText} />}
    </Form.Field>
  )
}

SemanticFormField.propTypes = {
  as: PropTypes.any,
  input: PropTypes.object,
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  infoProps: PropTypes.object,
  infoBefore: PropTypes.bool,
  infoText: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/SemanticFormFieldWithInfo.js